export enum ResponseStatus {
    SUCCESS = 200,
    CREATED = 201,
    NO_CONTENT = 204,
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    INTERNAL_SERVER_ERROR = 500,
}

export enum ErrorCode {
    OK = 0,
    // 服务器错误
    SERVER_ERROR = -999,
}

export interface ResponseData<T = any> {
    code: ErrorCode;
    message?: string;
    total?: number;
    totalPages?: number;
    currentPage?: number;
    data?: T;
}

export interface ImportResponseData {
    code: ErrorCode;
    message?: string;
    totalCount?: number;
    validCount?: number;
    invalidCount?: number;
}

export interface UploadImageResponseData {
    code: ErrorCode;
    message?: string;
    images?: any;
}

export interface ReminderSettingResponseData {
    code: ErrorCode;
    message?: string;
    inventory_id?: string;
    user_id?: string;
    type?: string;
    is_actived?: number;
}